import { useEffect, useState } from "react";
import { useInView } from "../hooks/useInView";

export const Counter = ({ to, duration = 1800, suffix = "" }) => {
    const [val, setVal] = useState(0);
    const [ref, inView] = useInView();

    useEffect(() => {
        if (!inView) return undefined;
        let raf = 0;
        const start = performance.now();
        const tick = (now) => {
            const p = Math.min(1, (now - start) / duration);
            setVal(Math.floor(p * to));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, to, duration]);

    return (
        <span ref={ref}>
            {val.toLocaleString("es-CO")}
            {suffix}
        </span>
    );
};
